<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_6"></a><span class="small">TO MY PARENTS,<br/>CARL AND DOROTHY MIELKE</span></p>
<p class="dedication"><img alt="image" src="html/images/f0006-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292747364_05_ded.vue?32724dfb